































































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment';
import { Form, Menu } from 'element-ui';
import {
  mapState,
  mapActions
} from 'vuex';
import {
  exportFiles,
  formatUrl,
  exportPostFiles
} from '../common/util';
import config from '../config/index';
import store from '../store/store';
import introJs from 'intro.js';
import {
  TaskManageData
} from '../types/task';

declare var _hmt: any;

export default Vue.extend({
  name: 'TaskManage',
  data(): TaskManageData {
    return {
      $refs: {
        createTaskForm: Form
      },
      createTaskForm: {
        taskName: ''
      },
      isShowTask: false,
      rules: {
        taskName: [{
          required: true,
          validator: async (rule: any, value: any, callback: any) => {
            if (value === '') {
              callback(new Error('请输入文件夹名称'));
              return false;
            } else if (/^[\s]+$/.test(value)) {
              callback(new Error('文件夹名称不能都为空格'));
              return false;
            } else if (value.length > 50) {
              callback(new Error('文件夹名称不能大于50位'));
              return false;
            }
            if (await (this as any).checkTaskName()) {
              callback(new Error('该文件夹已存在'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }]
      },
      oldTaskName:'',
      searchData: {
        name: '', // 文件夹名/分组名
        startTime: '', // 开始时间
        endTime: '' ,// 结束时间
        isExport: false,
        checkSelfDBId: ''
      },
      pickerOption: {
        disabledDate(time: Date) {
          return time.getTime() > Date.now();
        }
      },
      listLoading: false,
      actionName: '',
      // isInit: true,
      taskId: '',
      taskName: '',
      taskList: [],
      copyTaskList: []
    };
  },
  computed: mapState({
    metaTaskList: (state: any) => store.getters.getTaskList,
    userInfo: (state: any) => store.getters.getUserInfo,
    isShowIntro: (state: any) => store.getters.getIntro
  }),
  watch: {
    isShowIntro(newVal) {
      if (newVal && (this.taskList.length === 0)) {
        this.taskList = [{
          createTime: '2019/7/8',
          paperCount: 2,
          taskId: '',
          taskName: '2019年教职工发表'
        }];
      } else {
        this.taskList = this.copyTaskList.concat([]);
      }
    }
  },
  methods: {
    // 创建文件夹/更改名称
    createTask(formName: string) {
      const action = this.actionName === '创建文件夹' ? 'post' : 'put';
      const url = this.actionName === '创建文件夹' ? 'CreateTask' : `UpdateTask?taskId=${this.taskId}&`;
      this.$refs[formName].validate((valid: any) => {
        if (valid) {
          if (url === "CreateTask") {
            this.$http[action](`/api/TaskManage/${url}`, {taskName: this.createTaskForm.taskName}).then((res: any) => {
            if (res && res.status === 200) {
              this.$message({
                message: `${this.actionName}成功`,
                duration: 5000,
                center: true,
                type: 'success'
              });
              this.changeShowDialog(false);
              // this.$store.dispatch('setTaskList');
              this.getTaskList();
            } else {
              this.$message({
                message: `${this.actionName}失败`,
                duration: 5000,
                center: true,
                type: 'error'
              });
            }
          });
          } else {
            this.$http[action](`/api/TaskManage/${url}taskName=${encodeURIComponent(this.createTaskForm.taskName)}`).then((res: any) => {
              if (res && res.status === 200) {
                this.$message({
                  message: `${this.actionName}成功`,
                  duration: 5000,
                  center: true,
                  type: 'success'
                });
                this.changeShowDialog(false);
                // this.$store.dispatch('setTaskList');
                this.getTaskList();
              } else {
                this.$message({
                  message: `${this.actionName}失败`,
                  duration: 5000,
                  center: true,
                  type: 'error'
                });
              }
            });
          }
          

        }
      });
    },
    // 删除文件夹
    delTask(taskId: string) {
      this.$confirm('删除文件夹将会清空该文件夹下所有检测信息的文件夹归属，建议您将文件夹下的检测信息转移至其他文件夹再删除本文件夹，是否确认删除本文件夹？', '提示', { type: 'warning' }).then(() => {
        this.$http.delete(`/api/TaskManage/DeleteTask?taskId=${taskId}`).then((res: any) => {
          if (res && res.status === 200) {
            this.$message({
              message: `删除成功`,
              duration: 5000,
              center: true,
              type: 'success'
            });
            // this.$store.dispatch('setTaskList');
            this.getTaskList();
          } else {
            this.$message({
              message: `删除失败`,
              duration: 5000,
              center: true,
              type: 'error'
            });
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          duration: 5000,
          center: true,
          message: '已取消删除'
        });
      });
    },
    // 获取文件夹列表
    getTaskList() {
      if (this.searchData.startTime > this.searchData.endTime) {
        this.$alert(' 开始时间不能大于结束时间！', '提示');
        return false;
      }
      this.listLoading = true;
      this.$http.get('/api/TaskManage/GetTaskList', {
        params: this.searchData
      }).then((data: any) => {
        this.listLoading = false;
        this.taskList = data.data;
        this.copyTaskList = this.taskList.concat([]);
      });
    },
    // 清除查询条件
    clear() {
      this.searchData = {
        name: '',
        startTime:  moment(this.searchData.endTime).subtract(1, 'year').format('YYYY-MM-DD'),
        endTime: moment().format('YYYY-MM-DD'),
        isExport: false,
        checkSelfDBId: ''
      };
     
      this.getTaskList();
    },
    // 导出
    exportFile() {
      this.searchData.isExport = true
      exportFiles(formatUrl(this.searchData, `${config.api}/api/TaskManage/GetTaskList`));
      this.searchData.isExport = false;
    },
    // 检测文件夹名称是否存在
    async checkTaskName() {
      if(this.oldTaskName == this.createTaskForm.taskName){
        return false
      }
      return this.$http.get('/api/TaskManage/IsExistTask', {
        params: this.createTaskForm
      }).then((res: any) => res.data);
    },
    // 检测时间发生变化时触发
    changeTime() {
      // 日期转成字符串比较
      // this.searchData.beginTime = new Date(this.searchData.beginTime).toJSON();
      // this.searchData.endTime = new Date(this.searchData.endTime).toJSON();
    },
    // 显示创建文件夹弹窗
    changeShowDialog(mark: boolean, taskId?: string, taskName?: string) {
      this.taskName = taskName;
      this.isShowTask = mark;
      this.taskId = taskId;
      this.actionName = taskId ? '更改名称' : '创建文件夹';
      if(taskName) this.oldTaskName = taskName;
      if (taskId) {
        this.createTaskForm.taskName = taskName || '';
      } else {
        this.createTaskForm.taskName = '';
      }
      if (!mark) {
        this.$refs.createTaskForm.resetFields();
      }
    },
    // 跳转页面
    toUrl(taskid: string) {
      let path = '/myCheckInfo';
      this.$router.push({
        path,
        query: {
          taskid: encodeURIComponent(taskid)
        }
      });
    }
  },
  async mounted() {
    this.searchData.endTime = moment().format('YYYY-MM-DD');
    this.searchData.startTime = moment(this.searchData.endTime).subtract(1, 'year').format('YYYY-MM-DD');
    this.getTaskList();
  }
});
